<div>
  <Navbar />
  <Sidebar />

  <div class="page-wrapper">
    <div class="hero-section w-100">
      <div class="container-fluid">

        <div class="card rounded border-0 shadow-sm mb-4">

          <div class="card-header bg-white border-0">
            <div class="page-header mb-0">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="page-title mb-0">
                  User <span class="gradient-text">Information</span>
                </h3>
                <div class="d-flex gap-2">
                  <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2" @click="$router.back()">
                    <i class="fas fa-arrow-left me-2"></i>Back
                  </button>
                  <button
                    v-if="!edit_mode"
                    class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
                    @click="edit_mode = true"
                  >
                    <i class="fas fa-edit me-2"></i>Edit
                  </button>
                  <button
                    v-else
                    class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
                    @click="save_changes"
                    :disabled="saving"
                  >
                    <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                    <i v-else class="fas fa-save me-2"></i>
                    {{ saving ? 'Saving...' : 'Save Changes' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">

            <div class="profile-card">
              <div class="section-container">
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">First Name</label>
                      <input
                        class="form-input"
                        v-model="user.first_name"
                        :disabled="!edit_mode"
                        placeholder="Enter first name"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Last Name</label>
                      <input
                        class="form-input"
                        v-model="user.last_name"
                        :disabled="!edit_mode"
                        placeholder="Enter last name"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Email</label>
                      <input
                        class="form-input"
                        v-model="user.email"
                        @input="on_email_input"
                        @blur="email_touched = true"
                        :class="{'is-invalid': email_touched && !is_email_valid}"
                        placeholder="Enter email address"
                        disabled
                      >
                      <div v-if="email_touched && !is_email_valid" class="invalid-feedback">
                        {{ email_error || 'Please enter a valid email address.' }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Role</label>
                      <input
                        class="form-input"
                        v-model="user.role"
                        disabled
                        placeholder="User role"
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="user.client_type && user.client_type.toLowerCase() === 'organization'" class="section-container mt-4">
                <h5 class="section-title mb-4">
                  <i class="fas fa-building me-2"></i>Organization Details
                </h5>
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Organization Name</label>
                      <input
                        class="form-input"
                        v-model="new_company.company_name"
                        :disabled="!edit_mode"
                        placeholder="Enter organization name"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Registration Number</label>
                      <input
                        class="form-input"
                        placeholder="YYYY/NNNNNN/NN"
                        v-model="new_company.registration_number"
                        :disabled="!edit_mode"
                        @input="on_registration_input"
                        @keypress="only_digits($event)"
                        :class="{'is-invalid': registration_error}"
                      >
                      <div v-if="registration_error" class="invalid-feedback">{{ registration_error }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">VAT Number</label>
                      <input
                        class="form-input"
                        placeholder="0123456789"
                        v-model="new_company.vat_number"
                        :disabled="!edit_mode"
                        @keypress="only_digits($event)"
                        @input="validate_vat"
                        :class="{'is-invalid': vat_error}"
                      >
                      <div v-if="vat_error" class="invalid-feedback">{{ vat_error }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Phone Number</label>
                      <input
                        class="form-input"
                        v-model="new_company.phone_number"
                        :disabled="!edit_mode"
                        @keypress="only_digits($event)"
                        placeholder="Enter phone number"
                      >
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Address</label>
                      <input
                        class="form-input"
                        v-model="new_company.address"
                        :disabled="!edit_mode"
                        placeholder="Enter organization address"
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Individual Details Section -->
              <div v-else class="section-container mt-4">
                <h5 class="section-title mb-4">
                  <i class="fas fa-user me-2"></i>Individual Details
                </h5>
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Phone Number</label>
                      <input
                        class="form-input"
                        v-model="user_profile.phone_number"
                        :disabled="!edit_mode"
                        @keypress="only_digits($event)"
                        placeholder="Enter phone number"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Address</label>
                      <input
                        class="form-input"
                        v-model="user_profile.address"
                        :disabled="!edit_mode"
                        placeholder="Enter address"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">ID Number</label>
                      <input
                        class="form-input"
                        v-model="user_profile.id_number"
                        :disabled="!edit_mode"
                        @input="validate_id_number"
                        @keypress="only_digits($event)"
                        :class="{'is-invalid': id_number_error}"
                        placeholder="Enter ID number"
                      >
                      <div v-if="id_number_error" class="invalid-feedback">{{ id_number_error }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Province</label>
                      <input
                        class="form-input"
                        v-model="user_profile.province"
                        :disabled="!edit_mode"
                        placeholder="Enter province"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Country</label>
                      <input
                        class="form-input"
                        v-model="user_profile.country"
                        :disabled="!edit_mode"
                        placeholder="Enter country"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-modern">
                      <label class="form-label-modern">Gender</label>
                      <select
                        class="form-input"
                        v-model="user_profile.gender"
                        :disabled="!edit_mode"
                      >
                        <option value="">Select gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<PoweredBy/>